module.exports = __webpack_public_path__ + "img/plus.c5729fe2.svg";